// extracted by mini-css-extract-plugin
export var text = "_1d-0";